export default __webpack_public_path__ + "static/Elevation_Colour_White-8b6446f1eb32f760addf52be21db95ee.png";